export default "__VITE_ASSET__DcL8ekZ1__"